import React from "react";
import Project from "../Components/project";
import Sarita from "../details";

const MyProjects = () => {
    return (
        <>
            <Project props={Sarita} />
        </>
    )
}

export default MyProjects;